import React, { Component } from 'react';
import { getFlapIcon, isEmpty } from '../../../../Common/Common';

export default class Flap extends Component {
	constructor(props) {
		super(props);
		let flap = 1;
		let flap_steps = 5;
		
		if (!isEmpty(this.props.point_info)) {
			flap = this.props.point_info.flap;
			flap_steps = this.props.point_info.flap_cap.D != null ? this.props.point_info.flap_cap.D : 5;
		}
		
		let icon = getFlapIcon(flap_steps, flap)

		this.state = {
			flap: flap,
			icon: icon
		}
	}

	handleChangeFlap = () => {
		let flap = this.state.flap;
		if (flap == null) flap = 'A';
		let flap_steps = null;
		let is_auto_cap = false;
		if (!isEmpty(this.props.point_info)) {
			flap_steps = this.props.point_info.flap_cap.D != null ? this.props.point_info.flap_cap.D : 5;
			if (this.props.point_info.flap_cap.A == true) is_auto_cap = true;
		}

		if(flap_steps == 1) {
			if(is_auto_cap) {	//If auto cap is true
				switch(flap) {
					case 'S':
						flap = 'N';
					  	break;
					case 'N':
						flap = 'A';
					  	break;
					case 'A':
					default:
						flap = 'S';
				}
			} else {			//If auto cap is false
				switch(flap) {
					case 'S':
						flap = 'N';
					  	break;
					case 'N':
					default:
						flap = 'S';
				}
			}
		} else if(flap_steps == 5) {
			switch(flap) {
				case 'S':
			if (is_auto_cap) flap = 'A';
			else flap = 4;
					break;
				case 'A':
					flap = 4;
					break;
				case 4:
					flap = 3;
					break;
				case 3:
					flap = 2;
					break;
				case 2:
					flap = 1;
					break;
				case 1:
					flap = 0;
					break;
				case 0:
				default:
					flap = 'S';
			}
		}

		this.setState({
			flap: flap,
			icon: getFlapIcon(flap_steps, flap),
		})

		this.props.handleChangeFlap(flap);
	}

	render() {
		let flap_label = this.state.flap;
		if (this.state.flap == 'S') flap_label = this.props.receiver.getString('swing');
		else if (this.state.flap == 'A') flap_label = this.props.receiver.getString('auto');

		return (
			<div id='flap' style={this.props.style} onClick={this.handleChangeFlap}>
				<div>
					<img src={this.state.icon} style={{ width: 40 }} />
				</div>
				<div>
					<span> {this.props.receiver.getString('flap')} </span>
				</div>
			</div>
		)
	}
}